module.exports = __webpack_public_path__ + "static/media/mobiprint.8d264427.jpg";